<div class="subBlockContainer" id="createtenant">
  <div class="subBlockContent">        
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="chid-body" [formGroup]="consentCheckboxControl">
      <div class="inner-subBlock-wrapper">
        <div id="upload-sku">
          <mat-tab-group #tabs class="mat-tab-labels" (selectedTabChange)="myTabSelectedTabChange($event)">
            <mat-tab label="VIP Market Place Migrations">
              <div class="tab-content" id="pills-tabContent">
                <div [formGroup]="userFormGroup" class="col-md-12">
                  <div class="userinfo" style="padding-top: 15px;">
                    <div>
                      <mat-form-field [floatLabel]="'always'" style="width: 50%;">
                        <input matInput class="resellerIdValidate" formControlName="membershipId" placeholder="MEMBERSHIP ID" required>
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-slide-toggle
                        style="margin-bottom: 10px;"
                        formControlName="ignoreOrderReturnControl"
                      >
                        Ignore Order Return
                      </mat-slide-toggle>
                    </div>
                    <div>
                      <mat-slide-toggle
                        style="margin-bottom: 10px;"
                        formControlName="expirePurchaseAuthorizations"
                      >
                        Expire Purchase Authorizations
                      </mat-slide-toggle>
                    </div>
                  </div>
                  <div>
                    <button class="button button-red button-round"
                      (click)="transferPreview()"
                      [disabled]="previewResult?.length || preivewLoading">
                      &nbsp;Preview Subscriptions&nbsp;
                    </button>
                    <button *ngIf="previewResult?.length" class="button button-red button-round"
                      style="margin-left: 10px;"
                      [disabled]="disableRequest"
                      (click)="resetPage()"
                      >
                      &nbsp;Reset Page&nbsp;
                    </button>

                    <span *ngIf="showHVDDisclaimer" style="font-weight: bold;">
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Customer is eligible for High Volume Discount</span>
                  </div>
                <mat-spinner style="margin: auto;" mode="indeterminate"
                  class="circle cSPCustomerEntitlements-loading" diameter="20"
                  *ngIf="preivewLoading">
                </mat-spinner>
                </div>
                <div class="my-4" *ngIf="previewResult?.length" >
                  <div style="overflow-y: auto;">
                    <table mat-table [dataSource]="previewResult">
                      <ng-container matColumnDef="stkDesc">
                        <th class="align-center" mat-header-cell *matHeaderCellDef width="25%" class="align-left"
                          class="table-column">STOCK DESCRIPTION</th>
                          <td class="align-center" mat-cell *matCellDef="let element" width="25%" class="align-left"
                          class="tb-row" style="white-space: pre;">{{ element.stockDescription }}</td>
                      </ng-container>
                      <ng-container matColumnDef="quantity">
                        <th *matHeaderCellDef class="align-right table-column" width="25%">QTY</th>
                        <td class="align-right tb-row" mat-cell *matCellDef="let element" style="white-space: pre;">
                          {{ element.quantity}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="offerId">
                        <th class="align-center" mat-header-cell *matHeaderCellDef width="25%" class="align-left"
                          class="table-column">OFFER ID</th>
                          <td class="align-center" mat-cell *matCellDef="let element" width="25%" class="align-left"
                          class="tb-row" style="white-space: pre;">{{ element.offerId}}</td>
                      </ng-container>
        
                      <ng-container matColumnDef="renewalDate">
                        <th class="align-center" class="align-center" style="padding-left: 1%; padding-right: 1%;"
                          mat-header-cell *matHeaderCellDef width="25%">RENEWAL DATE</th>
                        <td class="align-center tb-row" mat-cell *matCellDef="let element" width="25%" style="white-space: pre;">
                          {{ element.renewalDate }}
                        </td>
                      </ng-container>

                      <!-- <ng-container matColumnDef="renewalDate">
                        <td mat-footer-cell *matFooterCellDef >
                          <span style="font-weight: bold;color: black !important;">Renewal Date: </span> {{ previewResult[0].renewalDate }}
                        </td>
                      </ng-container> -->
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                      <!-- <tr mat-footer-row *matFooterRowDef="['renewalDate']"></tr> -->
                    </table>
                  </div>
                </div>

                <ng-container *ngIf="showNoResult">
                  <div class="noResult-wrapper">
                    <div><img src="../images/new_ui/no-found.png"></div>
                    <div>No Subscriptions found. Click Migrate Now to proceed with migrating this Customer</div>
                  </div>
                </ng-container>

                <div class="row" *ngIf="showTransferButton">
                  <div class="col-md-10" formArrayName="consentControl">
                    <div *ngFor="let c of consents.controls; let i = index">
                      
                      <ng-container [formGroupName]="i">
                        <div class="row">
                          <div class="col-md-1">
                            <mat-checkbox  formControlName="isActive" style="margin: 0px 30px;">
                            </mat-checkbox>
                          </div>

                          <div class="col-md-11">
                            <span class="text-wrap">
                              {{ c.get('name').value}}
                            </span>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div>
                      <button
                        name="CREATEALL"
                        class="button button-red button-round" 
                        [disabled]="disableRequest || !authService?.currentUserHasPurchaseAccess() || hasUncheckedConsent()"
                        [matTooltipDisabled]="authService?.currentUserHasPurchaseAccess()"
                        matTooltip="Requires Purchasing Permissions"
                        (click)="transferSubscriptions()"
                        >
                        &nbsp;Proceed / Confirm&nbsp;
                      </button>
                        
                    </div>
                  </div>
                </div>



              </div>
            </mat-tab>
            <mat-tab label="In-Process">
              <div class="tab-content" id="pills-tabContent">
                <div class="my-4">
                  <div>
                    <mat-spinner style="margin: auto;" mode="indeterminate"
                      class="circle cSPCustomerEntitlements-loading" diameter="20"
                      *ngIf="preivewLoading">
                    </mat-spinner>
                  </div>
                  <div class="my-4" *ngIf="inProcessResult?.length" >
                    <div style="overflow-y: auto;">
                      <table mat-table [dataSource]="inProcessResult">
                        <ng-container matColumnDef="transferId">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="33%" class="align-left"
                            class="table-column">TRANSFER ID</th>
                            <td class="align-center" mat-cell *matCellDef="let element" width="33%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.transferId}}</td>
                        </ng-container>
                        <ng-container matColumnDef="membershipId">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="33%" class="align-left"
                            class="table-column">MEMBERSHIP ID</th>
                            <td class="align-center" mat-cell *matCellDef="let element" width="33%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.membershipId}}</td>
                        </ng-container>
                        <ng-container matColumnDef="creationDate">
                          <th class="align-center" class="align-center" style="padding-left: 1%; padding-right: 1%;"
                            mat-header-cell *matHeaderCellDef width="33%">DATE CREATED</th>
                          <td class="align-center tb-row" mat-cell *matCellDef="let element" width="33%" style="white-space: pre;">
                            {{ element.dateCreated | date: 'dd/MM/yyyy'}}
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="33%" class="align-left"
                            class="table-column">STATUS</th>
                            <td class="align-center" mat-cell *matCellDef="let element" width="33%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.status}}</td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="inProcessDisplayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: inProcessDisplayedColumns"></tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab label="Archive">
              <div class="tab-content" id="pills-tabContent">
                <div class="my-4">
                  <div>
                    <mat-spinner style="margin: auto;" mode="indeterminate"
                      class="circle cSPCustomerEntitlements-loading" diameter="20"
                      *ngIf="preivewLoading">
                    </mat-spinner>
                  </div>
                  <div class="my-4" *ngIf="archiveResult?.length" >
                    <div style="overflow-y: auto;">
                      <table mat-table [dataSource]="archiveResult">
                        <ng-container matColumnDef="transferId">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="33%" class="align-left"
                            class="table-column">TRANSFER ID</th>
                            <td class="align-center" mat-cell *matCellDef="let element" width="33%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.transferId}}</td>
                        </ng-container>
                        <ng-container matColumnDef="membershipId">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="33%" class="align-left"
                            class="table-column">MEMBERSHIP ID</th>
                            <td class="align-center" mat-cell *matCellDef="let element" width="33%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.membershipId}}</td>
                        </ng-container>
                        <ng-container matColumnDef="creationDate">
                          <th class="align-center" class="align-center" style="padding-left: 1%; padding-right: 1%;"
                            mat-header-cell *matHeaderCellDef width="33%">Date Created</th>
                          <td class="align-center tb-row" mat-cell *matCellDef="let element" width="33%" style="white-space: pre;">
                            {{ element.dateCreated | date: 'dd/MM/yyyy'}}
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="33%" class="align-left"
                            class="table-column">STATUS</th>
                            <td class="align-center" mat-cell *matCellDef="let element" width="33%" class="align-left"
                            class="tb-row" style="white-space: pre;">{{ element.status}}
                            <mat-icon *ngIf="element.status == 'Error'" matSuffix class="editmpnidicon align-top"
                            style="vertical-align: middle !important;"
                            placement="bottom" matTooltip="{{element.errorMessage}}">
                            info</mat-icon>
                          </td>
                            
                        </ng-container>
                        <ng-container matColumnDef="manageButton">
                          <th class="align-center" mat-header-cell *matHeaderCellDef width="33%" class="align-left"
                            class="table-column"></th>
                            <td class="align-center" mat-cell *matCellDef="let element" width="33%" class="align-left"
                            class="tb-row" style="white-space: pre;">
                            <button
                              *ngIf="element?.status == 'Completed'"
                              class="button button-red button-round"
                              (click)="goToCustomer(element)">Manage
                          </button>
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="archiveDisplayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: archiveDisplayedColumns"></tr>
                      </table>
                    </div>
                  </div>
                </div>
                <!-- <loading-screen *ngIf="!loadContent" backDropWidth="420" (currentLoadingStatus)="onLoading($event)">
                </loading-screen> -->
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</div>
